import { Component, Input, OnInit } from '@angular/core';
import { BooleanInput, ContentStorageService } from '@ptl/global-components';
import { additionalPlanLinksContentKey } from '../enums/additional-plan-links.enum';
@Component({
  selector: 'app-additional-plan-links-storage',
  templateUrl: './additional-plan-links-storage.component.html',
  styleUrl: './additional-plan-links-storage.component.scss',
  standalone: false
})
export class AdditionalPlanLinksStorageComponent implements OnInit {
  @Input() additionalPlanLinksArray: string;
  @Input() @BooleanInput() hideContent: boolean = false;

  constructor(
    private contentStorageService: ContentStorageService
  ) { }

  ngOnInit(){
    this.storeContent();

  }

  
  storeContent() {
    if (this.additionalPlanLinksArray) {
      try {
        const listOfLinks = JSON.parse(this.additionalPlanLinksArray);
        const additionalLinksConfigs = [
          ["listOfLinks", new Map(listOfLinks.map(obj => [obj.linkId, [obj.hyperlinkText, obj.hyperlink]]))],
          ["hideContent", this.hideContent]
        ]
        const parsedContent: Map<any, any> = new Map(additionalLinksConfigs.map(obj => [obj[0], obj[1]]));
        this.contentStorageService.storeContentMapFromComponent(additionalPlanLinksContentKey, parsedContent);
        
      } catch (err) {
        console.log('JSON Content Parse and Map Error:', err);
      }
    }
  }
}
